import React, { useState, useContext } from "react"
import Note from "./Note"
import CreateArea from "./CreateArea"
import Axios from "axios"
import StateContext from "../StateContext"
import DispatchContext from "../DispatchContext"

var _id
function AddNote() {
  const appState = useContext(StateContext)
  const appDispatch = useContext(DispatchContext)
  const [notes, setNotes] = useState([])

  async function AddNotes(newNote) {
    try {
      console.log(newNote)
      appDispatch({ type: "addNote", data: newNote })
      const response = await Axios.post("/tasks", newNote, {
        headers: {
          Authorization: `Bearer ${appState.userData.token}`
        }
      })
      _id = response.data._id
      console.log(_id)
      console.log("Successfully created a post!", response)
    } catch (e) {
      console.log("there was a problem", e)
    }
    setNotes(prevNotes => {
      return [...prevNotes, newNote]
    })
  }

  async function deleteNote(id) {
    console.log(_id)
    console.log(appState.userData.user._id)
    try {
      const response = await Axios.delete("/tasks/" + _id, {
        headers: {
          Authorization: `Bearer ${appState.userData.token}`
        }
      })
      console.log(response)
    } catch (e) {
      console.log(e)
    }

    setNotes(prevNotes => {
      return prevNotes.filter((noteItem, index) => {
        return index !== id
      })
    })
  }
  return (
    <>
      <div id="wrap">
        <div id="main" className="container clear-top">
          <CreateArea onAdd={AddNotes} />
          {notes.map((noteItem, index) => {
            return <Note key={index} id={index} title={noteItem.title} content={noteItem.content} onDelete={deleteNote} />
          })}
        </div>
      </div>
    </>
  )
}
export default AddNote
